import { Drawer, Menu, MenuProps } from "antd";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MenuIcon from "./../../graphics/MenuIcon.png"; // Adjust path to your image
type MenuItem = Required<MenuProps>["items"][number];
interface IMobileMenuProps {
  menuItems: MenuItem[];
}
const MobileMenu: React.FC<IMobileMenuProps> = ({ menuItems }) => {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const location = useLocation();
  const showDrawer = () => {
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  return (
    <div className="my-mobile-menu">
      <img
        src={MenuIcon}
        alt="Menu Icon"
        style={{ width: "30px", cursor: "pointer" }}
        onClick={showDrawer}
      />
      <Drawer
        title="Menu"
        placement="left"
        onClose={closeDrawer}
        open={isDrawerVisible}
        style={{ padding: 0 }}
      >
        <Menu
          mode="vertical"
          selectedKeys={[location.pathname]}
          items={menuItems}
        />
      </Drawer>
    </div>
  );
};

export default MobileMenu;
